'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _banner_form = require('../components/banner_form');

var _banner_form2 = _interopRequireDefault(_banner_form);

var _home = require('../actions/home');

var _product_type = require('../actions/product_type');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Banner = _react2.default.createClass({
    displayName: 'Banner',
    handleSubmit: function handleSubmit(values) {
        this.props.dispatch((0, _home.postBannerImages)(values));
    },
    componentWillMount: function componentWillMount() {
        this.props.dispatch((0, _home.fetchBannerImages)());
        this.props.dispatch((0, _product_type.fetchProductTypesIfNeeded)());
    },
    handleDelete: function handleDelete(id) {
        this.props.dispatch((0, _home.deleteBannerImage)(id));
    },
    render: function render() {
        var _props = this.props,
            banners = _props.banners,
            productTypes = _props.productTypes;

        return _react2.default.createElement(
            'div',
            { id: 'banner-edit' },
            _react2.default.createElement(_banner_form2.default, { onSubmit: this.handleSubmit, banners: banners, handleDelete: this.handleDelete, productTypes: productTypes })
        );
    }
}); /**
     * Banner图管理页面
     */


var mapStateToProps = function mapStateToProps(store) {
    var banners = store.home.banners;
    var productTypes = store.productType.productTypes;

    return {
        banners: banners,
        productTypes: productTypes.items
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Banner);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/banner.js
// module id = 1567
// module chunks = 0